export default __webpack_public_path__ + "static/media/login_background.8da34faf.jpg";